@if (_isLoading()) {
  <p>Loading...</p>
} @else {
  @if (!documentsResource.error() && documentsResource.hasValue()) {
    <div class="medication-photo-wrapper">
      <div class="medication-photo">
        <h4>Medication photos</h4>
        <p>Credits left: {{ documentsResource.value().credits_left }}</p>

        @if(photosDocuments().files?.length) {
          <task-photos
            [photos]="photosDocuments().files"
            [diagnosis]="''"
            [types]="null"
            [visit]="visit()"
            [errorMessage]="null"
          ></task-photos>
        } @else {
          <div>No files uploaded.</div>
        }
      </div>
    </div>
  } @else {
    <div>Failed to fetch files.</div>
  }
}
